import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StudentVisitDeleteMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type StudentVisitDeleteMutation = { __typename?: 'Mutation', studentVisitDelete: { __typename?: 'StudentVisitPayload', recordId: string, record: { __typename?: 'StudentVisit', id: string, payed: boolean, published: boolean, studentId: string, trainingId: string, visitStatus: Types.VisitStatus, student: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }, training: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } }, errors?: Array<{ __typename?: 'StudentVisitDoesNotExistsProblem', message: string } | { __typename?: 'StudentVisitSaveProblem', message: string } | { __typename?: 'StudentVisitUpdateProblem', message: string }> | null } };

export type StudentVisitPublishUpdateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type StudentVisitPublishUpdateMutation = { __typename?: 'Mutation', studentVisitPublishUpdate: { __typename?: 'StudentVisitPayload', recordId: string, record: { __typename?: 'StudentVisit', id: string, payed: boolean, published: boolean, studentId: string, trainingId: string, visitStatus: Types.VisitStatus, student: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }, training: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } }, errors?: Array<{ __typename?: 'StudentVisitDoesNotExistsProblem', message: string } | { __typename?: 'StudentVisitSaveProblem', message: string } | { __typename?: 'StudentVisitUpdateProblem', message: string }> | null } };

export type StudentVisitStatusUpdateMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  status: Types.VisitStatus;
}>;


export type StudentVisitStatusUpdateMutation = { __typename?: 'Mutation', studentVisitStatusUpdate: { __typename?: 'StudentVisitPayload', recordId: string, record: { __typename?: 'StudentVisit', id: string, payed: boolean, published: boolean, studentId: string, trainingId: string, visitStatus: Types.VisitStatus, student: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }, training: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } }, errors?: Array<{ __typename?: 'StudentVisitDoesNotExistsProblem', message: string } | { __typename?: 'StudentVisitSaveProblem', message: string } | { __typename?: 'StudentVisitUpdateProblem', message: string }> | null } };

export type StudentVisitSaveMutationVariables = Types.Exact<{
  studentVisitInput: Types.StudentVisitInput;
}>;


export type StudentVisitSaveMutation = { __typename?: 'Mutation', studentVisitSave: { __typename?: 'StudentVisitPayload', recordId: string, record: { __typename?: 'StudentVisit', id: string, payed: boolean, published: boolean, studentId: string, trainingId: string, visitStatus: Types.VisitStatus, student: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }, training: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } }, errors?: Array<{ __typename?: 'StudentVisitDoesNotExistsProblem', message: string } | { __typename?: 'StudentVisitSaveProblem', message: string } | { __typename?: 'StudentVisitUpdateProblem', message: string }> | null } };

export type StudentVisitUpdateMutationVariables = Types.Exact<{
  studentVisitInput: Types.StudentVisitInputWithId;
}>;


export type StudentVisitUpdateMutation = { __typename?: 'Mutation', studentVisitUpdate: { __typename?: 'StudentVisitPayload', recordId: string, record: { __typename?: 'StudentVisit', id: string, payed: boolean, published: boolean, studentId: string, trainingId: string, visitStatus: Types.VisitStatus, student: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }, training: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } }, errors?: Array<{ __typename?: 'StudentVisitDoesNotExistsProblem', message: string } | { __typename?: 'StudentVisitSaveProblem', message: string } | { __typename?: 'StudentVisitUpdateProblem', message: string }> | null } };

export type StudentVisitQueryVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type StudentVisitQuery = { __typename?: 'Query', studentVisit?: { __typename?: 'StudentVisit', id: string, payed: boolean, published: boolean, studentId: string, trainingId: string, visitStatus: Types.VisitStatus, student: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }, training: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } } | null };

export type StudentVisitsQueryVariables = Types.Exact<{
  after?: Types.InputMaybe<Types.Scalars['ID']>;
  before?: Types.InputMaybe<Types.Scalars['ID']>;
  filter?: Types.InputMaybe<Types.StudentVisitFilter>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  last?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type StudentVisitsQuery = { __typename?: 'Query', studentVisits?: { __typename?: 'StudentVisitConnection', edges: Array<{ __typename?: 'StudentVisitEdge', cursor: string, node?: { __typename?: 'StudentVisit', id: string, payed: boolean, published: boolean, studentId: string, trainingId: string, visitStatus: Types.VisitStatus, student: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean }> | null }, training: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean } } } | null }>, pageInfo?: { __typename?: 'PageInfo', endCursor: string, hasNextPage?: boolean | null, startCursor: string } | null } | null };

export type VisitStatusesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type VisitStatusesQuery = { __typename?: 'Query', visitStatuses?: Array<Types.VisitStatus> | null };

export type StudentVisitsByTrainingQueryVariables = Types.Exact<{
  training: Types.Scalars['ID'];
}>;


export type StudentVisitsByTrainingQuery = { __typename?: 'Query', studentVisitsByTraining?: Array<{ __typename?: 'StudentVisit', id: string, payed: boolean, published: boolean, studentId: string, trainingId: string, visitStatus: Types.VisitStatus, student: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }, training: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } }> | null };

export type StudentVisitsGenerateMutationVariables = Types.Exact<{
  startDate?: Types.InputMaybe<Types.Scalars['Date']>;
  finishDate?: Types.InputMaybe<Types.Scalars['Date']>;
}>;


export type StudentVisitsGenerateMutation = { __typename?: 'Mutation', studentVisitsGenerate?: Array<{ __typename?: 'StudentVisit', id: string, payed: boolean, published: boolean, studentId: string, trainingId: string, visitStatus: Types.VisitStatus, student: { __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }, training: { __typename?: 'Training', coachIds?: Array<string> | null, headCoachId?: string | null, id: string, published: boolean, stadiumId?: string | null, teamId: string, time?: any | null, visits: number, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, stadium?: { __typename?: 'Stadium', id: string, latitude: number, longitude: number, name: string, placeId: string, published: boolean, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } | null, team: { __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } } } }> | null };

export type LastStudentVisitsGenerateMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type LastStudentVisitsGenerateMutation = { __typename?: 'Mutation', lastStudentVisitsGenerate?: Array<{ __typename?: 'Student', birthday?: any | null, creatorIds: Array<string>, id: string, fileName?: string | null, name: string, passportNum?: string | null, paymentSum?: number | null, published: boolean, teamIds: Array<string>, address?: string | null, description?: string | null, school?: string | null, lastVisits?: Array<string> | null, creators?: Array<{ __typename?: 'Creator', id: string, name: string, phone: string, published: boolean, userId?: string | null, cardDetails?: string | null, user?: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } | null }> | null, teams?: Array<{ __typename?: 'Team', ages: Array<Types.Age>, coachIds?: Array<string> | null, headCoachId?: string | null, headCoachPayment?: number | null, id: string, name: string, placeId: string, published: boolean, writable: boolean, coaches?: Array<{ __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } }> | null, headCoach?: { __typename?: 'Staff', birthday?: any | null, department: Types.Department, description?: string | null, fileName?: string | null, id: string, name: string, orderNumber: number, phone?: string | null, published: boolean, userId: string, work: string, user: { __typename?: 'User', firstName: string, id: string, lastName: string, phone: string, roles: Array<Types.Role> } } | null, place: { __typename?: 'Place', address: string, description: string, id: string, name: string, orderNumber: number, published: boolean } }> | null }> | null };


export const StudentVisitDeleteDocument = gql`
    mutation studentVisitDelete($id: ID!) {
  studentVisitDelete(id: $id) {
    record {
      id
      payed
      published
      student {
        birthday
        creatorIds
        creators {
          id
          name
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          cardDetails
        }
        id
        fileName
        name
        passportNum
        paymentSum
        published
        teamIds
        teams {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          headCoachPayment
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        address
        description
        school
        lastVisits
      }
      studentId
      training {
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        published
        stadium {
          id
          latitude
          longitude
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
        }
        stadiumId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          headCoachPayment
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        time
        visits
      }
      trainingId
      visitStatus
    }
    recordId
    errors {
      ... on StudentVisitDoesNotExistsProblem {
        message
      }
      ... on StudentVisitSaveProblem {
        message
      }
      ... on StudentVisitUpdateProblem {
        message
      }
    }
  }
}
    `;
export type StudentVisitDeleteMutationFn = Apollo.MutationFunction<StudentVisitDeleteMutation, StudentVisitDeleteMutationVariables>;

/**
 * __useStudentVisitDeleteMutation__
 *
 * To run a mutation, you first call `useStudentVisitDeleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentVisitDeleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentVisitDeleteMutation, { data, loading, error }] = useStudentVisitDeleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentVisitDeleteMutation(baseOptions?: Apollo.MutationHookOptions<StudentVisitDeleteMutation, StudentVisitDeleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentVisitDeleteMutation, StudentVisitDeleteMutationVariables>(StudentVisitDeleteDocument, options);
      }
export type StudentVisitDeleteMutationHookResult = ReturnType<typeof useStudentVisitDeleteMutation>;
export type StudentVisitDeleteMutationResult = Apollo.MutationResult<StudentVisitDeleteMutation>;
export type StudentVisitDeleteMutationOptions = Apollo.BaseMutationOptions<StudentVisitDeleteMutation, StudentVisitDeleteMutationVariables>;
export const StudentVisitPublishUpdateDocument = gql`
    mutation studentVisitPublishUpdate($id: ID!) {
  studentVisitPublishUpdate(id: $id) {
    record {
      id
      payed
      published
      student {
        birthday
        creatorIds
        creators {
          id
          name
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          cardDetails
        }
        id
        fileName
        name
        passportNum
        paymentSum
        published
        teamIds
        teams {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          headCoachPayment
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        address
        description
        school
        lastVisits
      }
      studentId
      training {
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        published
        stadium {
          id
          latitude
          longitude
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
        }
        stadiumId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          headCoachPayment
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        time
        visits
      }
      trainingId
      visitStatus
    }
    recordId
    errors {
      ... on StudentVisitDoesNotExistsProblem {
        message
      }
      ... on StudentVisitSaveProblem {
        message
      }
      ... on StudentVisitUpdateProblem {
        message
      }
    }
  }
}
    `;
export type StudentVisitPublishUpdateMutationFn = Apollo.MutationFunction<StudentVisitPublishUpdateMutation, StudentVisitPublishUpdateMutationVariables>;

/**
 * __useStudentVisitPublishUpdateMutation__
 *
 * To run a mutation, you first call `useStudentVisitPublishUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentVisitPublishUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentVisitPublishUpdateMutation, { data, loading, error }] = useStudentVisitPublishUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentVisitPublishUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StudentVisitPublishUpdateMutation, StudentVisitPublishUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentVisitPublishUpdateMutation, StudentVisitPublishUpdateMutationVariables>(StudentVisitPublishUpdateDocument, options);
      }
export type StudentVisitPublishUpdateMutationHookResult = ReturnType<typeof useStudentVisitPublishUpdateMutation>;
export type StudentVisitPublishUpdateMutationResult = Apollo.MutationResult<StudentVisitPublishUpdateMutation>;
export type StudentVisitPublishUpdateMutationOptions = Apollo.BaseMutationOptions<StudentVisitPublishUpdateMutation, StudentVisitPublishUpdateMutationVariables>;
export const StudentVisitStatusUpdateDocument = gql`
    mutation studentVisitStatusUpdate($id: ID!, $status: VisitStatus!) {
  studentVisitStatusUpdate(id: $id, status: $status) {
    record {
      id
      payed
      published
      student {
        birthday
        creatorIds
        creators {
          id
          name
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          cardDetails
        }
        id
        fileName
        name
        passportNum
        paymentSum
        published
        teamIds
        teams {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          headCoachPayment
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        address
        description
        school
        lastVisits
      }
      studentId
      training {
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        published
        stadium {
          id
          latitude
          longitude
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
        }
        stadiumId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          headCoachPayment
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        time
        visits
      }
      trainingId
      visitStatus
    }
    recordId
    errors {
      ... on StudentVisitDoesNotExistsProblem {
        message
      }
      ... on StudentVisitSaveProblem {
        message
      }
      ... on StudentVisitUpdateProblem {
        message
      }
    }
  }
}
    `;
export type StudentVisitStatusUpdateMutationFn = Apollo.MutationFunction<StudentVisitStatusUpdateMutation, StudentVisitStatusUpdateMutationVariables>;

/**
 * __useStudentVisitStatusUpdateMutation__
 *
 * To run a mutation, you first call `useStudentVisitStatusUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentVisitStatusUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentVisitStatusUpdateMutation, { data, loading, error }] = useStudentVisitStatusUpdateMutation({
 *   variables: {
 *      id: // value for 'id'
 *      status: // value for 'status'
 *   },
 * });
 */
export function useStudentVisitStatusUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StudentVisitStatusUpdateMutation, StudentVisitStatusUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentVisitStatusUpdateMutation, StudentVisitStatusUpdateMutationVariables>(StudentVisitStatusUpdateDocument, options);
      }
export type StudentVisitStatusUpdateMutationHookResult = ReturnType<typeof useStudentVisitStatusUpdateMutation>;
export type StudentVisitStatusUpdateMutationResult = Apollo.MutationResult<StudentVisitStatusUpdateMutation>;
export type StudentVisitStatusUpdateMutationOptions = Apollo.BaseMutationOptions<StudentVisitStatusUpdateMutation, StudentVisitStatusUpdateMutationVariables>;
export const StudentVisitSaveDocument = gql`
    mutation studentVisitSave($studentVisitInput: StudentVisitInput!) {
  studentVisitSave(studentVisitInput: $studentVisitInput) {
    record {
      id
      payed
      published
      student {
        birthday
        creatorIds
        creators {
          id
          name
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          cardDetails
        }
        id
        fileName
        name
        passportNum
        paymentSum
        published
        teamIds
        teams {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          headCoachPayment
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        address
        description
        school
        lastVisits
      }
      studentId
      training {
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        published
        stadium {
          id
          latitude
          longitude
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
        }
        stadiumId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          headCoachPayment
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        time
        visits
      }
      trainingId
      visitStatus
    }
    recordId
    errors {
      ... on StudentVisitDoesNotExistsProblem {
        message
      }
      ... on StudentVisitSaveProblem {
        message
      }
      ... on StudentVisitUpdateProblem {
        message
      }
    }
  }
}
    `;
export type StudentVisitSaveMutationFn = Apollo.MutationFunction<StudentVisitSaveMutation, StudentVisitSaveMutationVariables>;

/**
 * __useStudentVisitSaveMutation__
 *
 * To run a mutation, you first call `useStudentVisitSaveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentVisitSaveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentVisitSaveMutation, { data, loading, error }] = useStudentVisitSaveMutation({
 *   variables: {
 *      studentVisitInput: // value for 'studentVisitInput'
 *   },
 * });
 */
export function useStudentVisitSaveMutation(baseOptions?: Apollo.MutationHookOptions<StudentVisitSaveMutation, StudentVisitSaveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentVisitSaveMutation, StudentVisitSaveMutationVariables>(StudentVisitSaveDocument, options);
      }
export type StudentVisitSaveMutationHookResult = ReturnType<typeof useStudentVisitSaveMutation>;
export type StudentVisitSaveMutationResult = Apollo.MutationResult<StudentVisitSaveMutation>;
export type StudentVisitSaveMutationOptions = Apollo.BaseMutationOptions<StudentVisitSaveMutation, StudentVisitSaveMutationVariables>;
export const StudentVisitUpdateDocument = gql`
    mutation studentVisitUpdate($studentVisitInput: StudentVisitInputWithId!) {
  studentVisitUpdate(studentVisitInput: $studentVisitInput) {
    record {
      id
      payed
      published
      student {
        birthday
        creatorIds
        creators {
          id
          name
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          cardDetails
        }
        id
        fileName
        name
        passportNum
        paymentSum
        published
        teamIds
        teams {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          headCoachPayment
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        address
        description
        school
        lastVisits
      }
      studentId
      training {
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        id
        published
        stadium {
          id
          latitude
          longitude
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
        }
        stadiumId
        team {
          ages
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          headCoachPayment
          id
          name
          place {
            address
            description
            id
            name
            orderNumber
            published
          }
          placeId
          published
          writable
        }
        teamId
        time
        visits
      }
      trainingId
      visitStatus
    }
    recordId
    errors {
      ... on StudentVisitDoesNotExistsProblem {
        message
      }
      ... on StudentVisitSaveProblem {
        message
      }
      ... on StudentVisitUpdateProblem {
        message
      }
    }
  }
}
    `;
export type StudentVisitUpdateMutationFn = Apollo.MutationFunction<StudentVisitUpdateMutation, StudentVisitUpdateMutationVariables>;

/**
 * __useStudentVisitUpdateMutation__
 *
 * To run a mutation, you first call `useStudentVisitUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentVisitUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentVisitUpdateMutation, { data, loading, error }] = useStudentVisitUpdateMutation({
 *   variables: {
 *      studentVisitInput: // value for 'studentVisitInput'
 *   },
 * });
 */
export function useStudentVisitUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StudentVisitUpdateMutation, StudentVisitUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentVisitUpdateMutation, StudentVisitUpdateMutationVariables>(StudentVisitUpdateDocument, options);
      }
export type StudentVisitUpdateMutationHookResult = ReturnType<typeof useStudentVisitUpdateMutation>;
export type StudentVisitUpdateMutationResult = Apollo.MutationResult<StudentVisitUpdateMutation>;
export type StudentVisitUpdateMutationOptions = Apollo.BaseMutationOptions<StudentVisitUpdateMutation, StudentVisitUpdateMutationVariables>;
export const StudentVisitDocument = gql`
    query studentVisit($id: ID!) {
  studentVisit(id: $id) {
    id
    payed
    published
    student {
      birthday
      creatorIds
      creators {
        id
        name
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        cardDetails
      }
      id
      fileName
      name
      passportNum
      paymentSum
      published
      teamIds
      teams {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        headCoachPayment
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      address
      description
      school
      lastVisits
    }
    studentId
    training {
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      id
      published
      stadium {
        id
        latitude
        longitude
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
      }
      stadiumId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        headCoachPayment
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      time
      visits
    }
    trainingId
    visitStatus
  }
}
    `;

/**
 * __useStudentVisitQuery__
 *
 * To run a query within a React component, call `useStudentVisitQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentVisitQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentVisitQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStudentVisitQuery(baseOptions: Apollo.QueryHookOptions<StudentVisitQuery, StudentVisitQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentVisitQuery, StudentVisitQueryVariables>(StudentVisitDocument, options);
      }
export function useStudentVisitLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentVisitQuery, StudentVisitQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentVisitQuery, StudentVisitQueryVariables>(StudentVisitDocument, options);
        }
export type StudentVisitQueryHookResult = ReturnType<typeof useStudentVisitQuery>;
export type StudentVisitLazyQueryHookResult = ReturnType<typeof useStudentVisitLazyQuery>;
export type StudentVisitQueryResult = Apollo.QueryResult<StudentVisitQuery, StudentVisitQueryVariables>;
export function refetchStudentVisitQuery(variables: StudentVisitQueryVariables) {
      return { query: StudentVisitDocument, variables: variables }
    }
export const StudentVisitsDocument = gql`
    query studentVisits($after: ID, $before: ID, $filter: StudentVisitFilter, $first: Int, $last: Int) {
  studentVisits(
    after: $after
    before: $before
    filter: $filter
    first: $first
    last: $last
  ) {
    edges {
      cursor
      node {
        id
        payed
        published
        student {
          birthday
          creatorIds
          creators {
            id
            name
            phone
            published
            userId
            cardDetails
          }
          id
          fileName
          name
          passportNum
          paymentSum
          published
          teamIds
          teams {
            ages
            coachIds
            headCoachId
            headCoachPayment
            id
            name
            placeId
            published
            writable
          }
          address
          description
          school
          lastVisits
        }
        studentId
        training {
          coachIds
          coaches {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoach {
            birthday
            department
            description
            fileName
            id
            name
            orderNumber
            phone
            published
            userId
            work
          }
          headCoachId
          id
          published
          stadium {
            id
            latitude
            longitude
            name
            placeId
            published
          }
          stadiumId
          team {
            ages
            coachIds
            headCoachId
            headCoachPayment
            id
            name
            placeId
            published
            writable
          }
          teamId
          time
          visits
        }
        trainingId
        visitStatus
      }
    }
    pageInfo {
      endCursor
      hasNextPage
      startCursor
    }
  }
}
    `;

/**
 * __useStudentVisitsQuery__
 *
 * To run a query within a React component, call `useStudentVisitsQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentVisitsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentVisitsQuery({
 *   variables: {
 *      after: // value for 'after'
 *      before: // value for 'before'
 *      filter: // value for 'filter'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *   },
 * });
 */
export function useStudentVisitsQuery(baseOptions?: Apollo.QueryHookOptions<StudentVisitsQuery, StudentVisitsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentVisitsQuery, StudentVisitsQueryVariables>(StudentVisitsDocument, options);
      }
export function useStudentVisitsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentVisitsQuery, StudentVisitsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentVisitsQuery, StudentVisitsQueryVariables>(StudentVisitsDocument, options);
        }
export type StudentVisitsQueryHookResult = ReturnType<typeof useStudentVisitsQuery>;
export type StudentVisitsLazyQueryHookResult = ReturnType<typeof useStudentVisitsLazyQuery>;
export type StudentVisitsQueryResult = Apollo.QueryResult<StudentVisitsQuery, StudentVisitsQueryVariables>;
export function refetchStudentVisitsQuery(variables?: StudentVisitsQueryVariables) {
      return { query: StudentVisitsDocument, variables: variables }
    }
export const VisitStatusesDocument = gql`
    query visitStatuses {
  visitStatuses
}
    `;

/**
 * __useVisitStatusesQuery__
 *
 * To run a query within a React component, call `useVisitStatusesQuery` and pass it any options that fit your needs.
 * When your component renders, `useVisitStatusesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVisitStatusesQuery({
 *   variables: {
 *   },
 * });
 */
export function useVisitStatusesQuery(baseOptions?: Apollo.QueryHookOptions<VisitStatusesQuery, VisitStatusesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VisitStatusesQuery, VisitStatusesQueryVariables>(VisitStatusesDocument, options);
      }
export function useVisitStatusesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VisitStatusesQuery, VisitStatusesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VisitStatusesQuery, VisitStatusesQueryVariables>(VisitStatusesDocument, options);
        }
export type VisitStatusesQueryHookResult = ReturnType<typeof useVisitStatusesQuery>;
export type VisitStatusesLazyQueryHookResult = ReturnType<typeof useVisitStatusesLazyQuery>;
export type VisitStatusesQueryResult = Apollo.QueryResult<VisitStatusesQuery, VisitStatusesQueryVariables>;
export function refetchVisitStatusesQuery(variables?: VisitStatusesQueryVariables) {
      return { query: VisitStatusesDocument, variables: variables }
    }
export const StudentVisitsByTrainingDocument = gql`
    query studentVisitsByTraining($training: ID!) {
  studentVisitsByTraining(training: $training) {
    id
    payed
    published
    student {
      birthday
      creatorIds
      creators {
        id
        name
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        cardDetails
      }
      id
      fileName
      name
      passportNum
      paymentSum
      published
      teamIds
      teams {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        headCoachPayment
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      address
      description
      school
      lastVisits
    }
    studentId
    training {
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      id
      published
      stadium {
        id
        latitude
        longitude
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
      }
      stadiumId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        headCoachPayment
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      time
      visits
    }
    trainingId
    visitStatus
  }
}
    `;

/**
 * __useStudentVisitsByTrainingQuery__
 *
 * To run a query within a React component, call `useStudentVisitsByTrainingQuery` and pass it any options that fit your needs.
 * When your component renders, `useStudentVisitsByTrainingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStudentVisitsByTrainingQuery({
 *   variables: {
 *      training: // value for 'training'
 *   },
 * });
 */
export function useStudentVisitsByTrainingQuery(baseOptions: Apollo.QueryHookOptions<StudentVisitsByTrainingQuery, StudentVisitsByTrainingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StudentVisitsByTrainingQuery, StudentVisitsByTrainingQueryVariables>(StudentVisitsByTrainingDocument, options);
      }
export function useStudentVisitsByTrainingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StudentVisitsByTrainingQuery, StudentVisitsByTrainingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StudentVisitsByTrainingQuery, StudentVisitsByTrainingQueryVariables>(StudentVisitsByTrainingDocument, options);
        }
export type StudentVisitsByTrainingQueryHookResult = ReturnType<typeof useStudentVisitsByTrainingQuery>;
export type StudentVisitsByTrainingLazyQueryHookResult = ReturnType<typeof useStudentVisitsByTrainingLazyQuery>;
export type StudentVisitsByTrainingQueryResult = Apollo.QueryResult<StudentVisitsByTrainingQuery, StudentVisitsByTrainingQueryVariables>;
export function refetchStudentVisitsByTrainingQuery(variables: StudentVisitsByTrainingQueryVariables) {
      return { query: StudentVisitsByTrainingDocument, variables: variables }
    }
export const StudentVisitsGenerateDocument = gql`
    mutation studentVisitsGenerate($startDate: Date, $finishDate: Date) {
  studentVisitsGenerate(startDate: $startDate, finishDate: $finishDate) {
    id
    payed
    published
    student {
      birthday
      creatorIds
      creators {
        id
        name
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        cardDetails
      }
      id
      fileName
      name
      passportNum
      paymentSum
      published
      teamIds
      teams {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        headCoachPayment
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      address
      description
      school
      lastVisits
    }
    studentId
    training {
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      id
      published
      stadium {
        id
        latitude
        longitude
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
      }
      stadiumId
      team {
        ages
        coachIds
        coaches {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoach {
          birthday
          department
          description
          fileName
          id
          name
          orderNumber
          phone
          published
          user {
            firstName
            id
            lastName
            phone
            roles
          }
          userId
          work
        }
        headCoachId
        headCoachPayment
        id
        name
        place {
          address
          description
          id
          name
          orderNumber
          published
        }
        placeId
        published
        writable
      }
      teamId
      time
      visits
    }
    trainingId
    visitStatus
  }
}
    `;
export type StudentVisitsGenerateMutationFn = Apollo.MutationFunction<StudentVisitsGenerateMutation, StudentVisitsGenerateMutationVariables>;

/**
 * __useStudentVisitsGenerateMutation__
 *
 * To run a mutation, you first call `useStudentVisitsGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStudentVisitsGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [studentVisitsGenerateMutation, { data, loading, error }] = useStudentVisitsGenerateMutation({
 *   variables: {
 *      startDate: // value for 'startDate'
 *      finishDate: // value for 'finishDate'
 *   },
 * });
 */
export function useStudentVisitsGenerateMutation(baseOptions?: Apollo.MutationHookOptions<StudentVisitsGenerateMutation, StudentVisitsGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StudentVisitsGenerateMutation, StudentVisitsGenerateMutationVariables>(StudentVisitsGenerateDocument, options);
      }
export type StudentVisitsGenerateMutationHookResult = ReturnType<typeof useStudentVisitsGenerateMutation>;
export type StudentVisitsGenerateMutationResult = Apollo.MutationResult<StudentVisitsGenerateMutation>;
export type StudentVisitsGenerateMutationOptions = Apollo.BaseMutationOptions<StudentVisitsGenerateMutation, StudentVisitsGenerateMutationVariables>;
export const LastStudentVisitsGenerateDocument = gql`
    mutation lastStudentVisitsGenerate {
  lastStudentVisitsGenerate {
    birthday
    creatorIds
    creators {
      id
      name
      phone
      published
      user {
        firstName
        id
        lastName
        phone
        roles
      }
      userId
      cardDetails
    }
    id
    fileName
    name
    passportNum
    paymentSum
    published
    teamIds
    teams {
      ages
      coachIds
      coaches {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoach {
        birthday
        department
        description
        fileName
        id
        name
        orderNumber
        phone
        published
        user {
          firstName
          id
          lastName
          phone
          roles
        }
        userId
        work
      }
      headCoachId
      headCoachPayment
      id
      name
      place {
        address
        description
        id
        name
        orderNumber
        published
      }
      placeId
      published
      writable
    }
    address
    description
    school
    lastVisits
  }
}
    `;
export type LastStudentVisitsGenerateMutationFn = Apollo.MutationFunction<LastStudentVisitsGenerateMutation, LastStudentVisitsGenerateMutationVariables>;

/**
 * __useLastStudentVisitsGenerateMutation__
 *
 * To run a mutation, you first call `useLastStudentVisitsGenerateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLastStudentVisitsGenerateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [lastStudentVisitsGenerateMutation, { data, loading, error }] = useLastStudentVisitsGenerateMutation({
 *   variables: {
 *   },
 * });
 */
export function useLastStudentVisitsGenerateMutation(baseOptions?: Apollo.MutationHookOptions<LastStudentVisitsGenerateMutation, LastStudentVisitsGenerateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LastStudentVisitsGenerateMutation, LastStudentVisitsGenerateMutationVariables>(LastStudentVisitsGenerateDocument, options);
      }
export type LastStudentVisitsGenerateMutationHookResult = ReturnType<typeof useLastStudentVisitsGenerateMutation>;
export type LastStudentVisitsGenerateMutationResult = Apollo.MutationResult<LastStudentVisitsGenerateMutation>;
export type LastStudentVisitsGenerateMutationOptions = Apollo.BaseMutationOptions<LastStudentVisitsGenerateMutation, LastStudentVisitsGenerateMutationVariables>;